/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import Grid from '@tcp/core/src/components/common/molecules/Grid';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import ReactToolTip from '@tcp/core/src/components/common/atoms/ReactToolTip';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import { PRICING_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import {
  getLocator,
  getIconPath,
  getAfterPaySize,
  isCanada,
  isMobileWeb,
} from '@tcp/core/src/utils';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty.js';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import { currencyConversion } from '@tcp/core/src/components/features/CnC/CartItemTile/utils/utils';
import OrderSummarySkeleton from '@tcp/core/src/components/features/CnC/common/organism/OrderLedger/skeleton/OrderSummarySkeleton.view';
import AfterPayMessaging from '@tcp/core/src/components/common/organisms/AfterPayMessaging/container/AfterPayMessaging.container';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import EstimatedTaxComponent from '../../../molecules/EstimatedTax';
import LoyaltyBanner from '../../../../LoyaltyBanner';
import FreeShippingBanner from '../../../../FreeShippingBanner';
import PlccCheckout from '../molecules/plccCard/PlccCheckout.view';
import CardImage from '../../../../../../common/molecules/CardImage';
import orderLedgerLabels, { GLOBAL_CARTITEM, lblTotalSavingsLabel } from './orderLedger.labels';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblItems,
  lblOr,
  lblShipping,
  lblItemSubtotal,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import BAGPAGE_CONSTANTS from '../../../../BagPage/BagPage.constants';

const STYLE_CHANGE_CLASS = 'text-style-change';

const createRowForGiftServiceTotal = (
  className,
  giftServiceTotal,
  checkoutLabels,
  orderSubtotalEnhancementEnabled
) => {
  return (
    giftServiceTotal > 0 && (
      <Row
        className="shipping-total rowMargin"
        data-locator={getLocator('order_ledger_giftService_label')}
      >
        <Col colSize={{ large: 6, medium: 4, small: 3 }}>
          <BodyCopy
            bodySize="one"
            color="primary"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
            className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
          >
            {`${checkoutLabels.bagPage?.lbl_orderledger_giftServices}: `}
          </BodyCopy>
        </Col>
        <Col colSize={{ large: 6, medium: 4, small: 3 }}>
          <BodyCopy
            bodySize="one"
            color="primary"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
            className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
            textAlign="right"
          >
            <PriceCurrency price={giftServiceTotal} />
          </BodyCopy>
        </Col>
      </Row>
    )
  );
};

const renderEstimatedTaxes = (taxesTotal, checkoutLabels, orderSubtotalEnhancementEnabled) => {
  return (
    <Row
      className="tax-total rowMargin"
      data-locator={getLocator('order_ledger_estimated_tax_label')}
    >
      {taxesTotal >= 0 ? (
        <>
          <Col colSize={{ large: 6, medium: 4, small: 3 }}>
            <BodyCopy
              bodySize="one"
              tag="span"
              color="primary"
              fontFamily="secondary"
              fontWeight="semibold"
              fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
              className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
            >
              {`${checkoutLabels.bagPage?.lbl_orderledger_tax}:`}
            </BodyCopy>
          </Col>
          <Col colSize={{ large: 6, medium: 4, small: 3 }}>
            <BodyCopy
              bodySize="one"
              color="primary"
              fontFamily="secondary"
              fontWeight="semibold"
              fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
              textAlign="right"
              className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
            >
              <PriceCurrency price={Number(taxesTotal)} />
            </BodyCopy>
          </Col>
        </>
      ) : null}
    </Row>
  );
};

export const renderLoyaltyBanner = (pageCategory) => {
  return (
    <div className="orderLedgerLoyalty">
      <LoyaltyBanner isFancyBanner={pageCategory === 'bagPage'} pageCategory={pageCategory} />
    </div>
  );
};

export const renderEstimatedTax = ({
  taxesTotal,
  isEstimatedTaxFormEnabled,
  zipCode,
  getEstimatedTaxAction,
  getIsFromEstimatedTaxForm,
  taxFromDefaultShippingAddress,
  zipCodeTaxError,
  isTaxCalculated,
  isNonCacheDataLoaded,
  plccShippingAddressUpdateActn,
  orderType,
  isAddToBagInProgress,
  checkoutLabels,
  orderSubtotalEnhancementEnabled,
}) => {
  return isEstimatedTaxFormEnabled ? (
    <>
      <EstimatedTaxComponent
        zipCodeTaxError={zipCodeTaxError}
        taxesTotal={taxesTotal}
        zipCode={zipCode}
        taxFromDefaultShippingAddress={taxFromDefaultShippingAddress}
        getIsFromEstimatedTaxForm={getIsFromEstimatedTaxForm}
        getEstimatedTaxAction={getEstimatedTaxAction}
        isTaxCalculated={isTaxCalculated}
        plccShippingAddressUpdateActn={plccShippingAddressUpdateActn}
        spc
        orderType={orderType}
        isAddToBagInProgress={isAddToBagInProgress}
        isNonCacheDataLoaded={isNonCacheDataLoaded}
        checkoutLabels={checkoutLabels}
      />
    </>
  ) : (
    renderEstimatedTaxes(taxesTotal, checkoutLabels, orderSubtotalEnhancementEnabled)
  );
};

export const renderCouponTotal = (couponsTotal, currencyAttributes, checkoutLabels) => {
  return couponsTotal ? (
    <Row
      className="coupons-total rowMargin"
      data-locator={getLocator('order_ledger_coupons_label')}
    >
      <Col colSize={{ large: 6, medium: 4, small: 3 }}>
        <BodyCopy
          bodySize="one"
          color="primary"
          fontFamily="secondary"
          fontWeight="semibold"
          fontSize="fs16"
        >
          {checkoutLabels.bagPage?.lbl_orderledger_coupons}
          {':'}
        </BodyCopy>
      </Col>
      <Col colSize={{ large: 6, medium: 4, small: 3 }}>
        <BodyCopy
          bodySize="one"
          color="primary"
          fontFamily="secondary"
          fontWeight="semibold"
          fontSize="fs16"
          textAlign="right"
        >
          -
          <PriceCurrency
            price={currencyConversion(couponsTotal, currencyAttributes?.[0]) || couponsTotal}
          />
        </BodyCopy>
      </Col>
    </Row>
  ) : null;
};

const renderSavingsTotal = (savingsTotal, className, currencyAttributes, checkoutLabels) => {
  return savingsTotal ? (
    <Row
      className="promotions-total rowMargin"
      data-locator={getLocator('order_ledger_promotion_label')}
    >
      <Col colSize={{ large: 6, medium: 4, small: 3 }}>
        <BodyCopy
          bodySize="one"
          color="primary"
          fontFamily="secondary"
          fontWeight="semibold"
          fontSize="fs16"
        >
          {`${checkoutLabels.bagPage?.lbl_orderledger_promotions}:`}
        </BodyCopy>
      </Col>
      <Col colSize={{ large: 6, medium: 4, small: 3 }}>
        <BodyCopy
          bodySize="one"
          color="primary"
          fontFamily="secondary"
          fontWeight="semibold"
          fontSize="fs16"
          textAlign="right"
        >
          -
          <PriceCurrency
            price={currencyConversion(savingsTotal, currencyAttributes?.[0]) || savingsTotal}
          />
        </BodyCopy>
      </Col>
    </Row>
  ) : null;
};

const renderProductTotalWithDiscounts = (productTotal, className, currencyAttributes) => {
  return productTotal ? (
    <Row
      className="promotions-total elem-mb-XX rowMargin"
      data-locator={getLocator('order_ledger_promotion_label')}
    >
      <Col colSize={{ large: 6, medium: 4, small: 3 }} />
      <Col colSize={{ large: 6, medium: 4, small: 3 }}>
        <BodyCopy
          bodySize="one"
          color="primary"
          fontFamily="secondary"
          fontWeight="extrabold"
          fontSize="fs16"
          textAlign="right"
          className={STYLE_CHANGE_CLASS}
        >
          <PriceCurrency
            price={currencyConversion(productTotal, currencyAttributes?.[0]) || productTotal}
          />
        </BodyCopy>
      </Col>
    </Row>
  ) : null;
};

const shippingTotalCurrencySymbol = (shippingTotal, checkoutLabels) => {
  return shippingTotal > 0 ? (
    <PriceCurrency price={shippingTotal} />
  ) : (
    checkoutLabels.bagPage?.lbl_orderledger_free
  );
};

const orderHasShipping = (
  isOrderHasShipping,
  shippingTotal,
  checkoutLabels,
  showFreeShippingMsg,
  orderSubtotalEnhancementEnabled
) => {
  return (
    isOrderHasShipping && (
      <Row
        className={`shipping-total ${!showFreeShippingMsg ? 'rowMargin' : 'rowFreeShippingMargin'}`}
        data-locator={getLocator('order_ledger_shipping_label')}
      >
        <Col colSize={{ large: 6, medium: 4, small: 3 }}>
          <BodyCopy
            bodySize="one"
            color="primary"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
            className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
          >
            {`${getLabelFromCopyOrFromTranslation(
              `${GLOBAL_GENERIC_LABELS}.${lblShipping}`,
              GlobalGenericLabels
            )}:`}
          </BodyCopy>
        </Col>
        <Col colSize={{ large: 6, medium: 4, small: 3 }}>
          <BodyCopy
            bodySize="one"
            color="primary"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
            className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
            textAlign="right"
          >
            {shippingTotal !== undefined
              ? shippingTotalCurrencySymbol(shippingTotal, checkoutLabels)
              : '-'}
          </BodyCopy>
        </Col>
      </Row>
    )
  );
};

const freeShippingMessage = (freeShippingThreshold, orderSubtotalEnhancementEnabled) => {
  const freeShipsMsg = renderLabel(
    getDynamicLabelValues('dynamic.browse_d.lbl_ships_free_msg'),
    'lbl_ships_free_msg'
  )?.split('##');
  if (!freeShippingThreshold) {
    return null;
  }
  return (
    <Row
      className="shipping-total rowMargin"
      data-locator={getLocator('order_ledger_free_shipping_label')}
    >
      <BodyCopy
        color="green.1000"
        fontFamily="secondary"
        fontWeight="bold"
        fontSize={orderSubtotalEnhancementEnabled ? 'fs12' : 'fs13'}
      >
        {`${freeShipsMsg && freeShipsMsg[0] + freeShippingThreshold + freeShipsMsg[1]}*`}
      </BodyCopy>
    </Row>
  );
};

const conditionForSkeleton = (isConfirmationPage, ledgerSummaryData, bagLoading) => {
  return !isConfirmationPage
    ? !bagLoading && ledgerSummaryData && ledgerSummaryData.itemsCount > 0
    : true;
};

const renderGiftsCardTotal = (
  giftCardsTotal,
  checkoutLabels,
  grandTotal,
  spc,
  isConfirmationPage,
  orderSubtotalEnhancementEnabled
) => {
  return (
    giftCardsTotal > 0 && (
      <React.Fragment>
        {!isConfirmationPage && (
          <Row
            className="estimated-total rowMargin"
            data-locator={getLocator('order_ledger_estimated_total_label')}
          >
            <Col colSize={{ large: 6, medium: 4, small: 3 }}>
              <BodyCopy
                bodySize="one"
                color="primary"
                fontFamily="secondary"
                fontWeight="semibold"
                fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs13'}
                className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
              >
                {`${checkoutLabels.bagPage?.lbl_orderledger_total}:`}
              </BodyCopy>
            </Col>
            <Col colSize={{ large: 6, medium: 4, small: 3 }}>
              <BodyCopy
                bodySize="one"
                color="primary"
                fontFamily="secondary"
                fontWeight="semibold"
                fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs13'}
                textAlign="right"
                className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
              >
                <PriceCurrency price={grandTotal} />
              </BodyCopy>
            </Col>
          </Row>
        )}
        <Row
          fullBleed={spc}
          className="giftCard-total rowMargin"
          data-locator={getLocator('order_ledger_gift_card_label')}
        >
          <Col colSize={{ large: 6, medium: 4, small: 3 }}>
            <BodyCopy
              bodySize="one"
              color="primary"
              fontFamily="secondary"
              fontWeight="semibold"
              fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs13'}
              className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
            >
              {`${checkoutLabels?.bagPage?.lbl_orderledger_giftcards}:`}
            </BodyCopy>
          </Col>
          <Col colSize={{ large: 6, medium: 4, small: 3 }}>
            <BodyCopy
              bodySize="one"
              color="primary"
              fontFamily="secondary"
              fontWeight="semibold"
              fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs13'}
              textAlign="right"
              className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
            >
              -
              <PriceCurrency price={giftCardsTotal} />
            </BodyCopy>
          </Col>
        </Row>
      </React.Fragment>
    )
  );
};

const renderTotalOrderSavings = (
  totalOrderSavings,
  grandTotal,
  toolTipMinWidth,
  currencyAttributes,
  checkoutLabels,
  orderSubtotalEnhancementEnabled
) => {
  return (
    totalOrderSavings > 0 && (
      <Row
        className="total-order-savings rowMargin"
        data-locator={getLocator('order_ledger_total_order_savings_label')}
      >
        <Col colSize={{ large: 6, medium: 5, small: 3 }}>
          <BodyCopy
            bodySize="one"
            color="primary"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
            className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
          >
            {`${getLabelFromCopyOrFromTranslation(
              `${GLOBAL_CARTITEM}.${lblTotalSavingsLabel}`,
              orderLedgerLabels
            )}`}
            <ReactToolTip
              id="tool"
              direction="top"
              message={checkoutLabels.bagPage?.lbl_orderledger_tooltiptext}
              minWidth={toolTipMinWidth}
            >
              <Image alt="info" className="circle-info-image" src={getIconPath(`info-icon`)} />
            </ReactToolTip>
          </BodyCopy>
        </Col>
        <Col colSize={{ large: 6, medium: 3, small: 3 }}>
          <BodyCopy
            bodySize="one"
            color="primary"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
            className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
            textAlign="right"
          >
            <PriceCurrency
              price={
                currencyConversion(totalOrderSavings, currencyAttributes?.[0]) || totalOrderSavings
              }
            />
          </BodyCopy>
        </Col>
      </Row>
    )
  );
};
const renderCouponsAndPromoTotal = (
  savingsTotal,
  className,
  currencyAttributes,
  checkoutLabels,
  couponsTotal
) => {
  const totalPrice = savingsTotal + couponsTotal;
  let labelObj = { label: '', price: 0 };
  if (couponsTotal && savingsTotal) {
    labelObj = {
      label: `${checkoutLabels.bagPage?.lbl_orderledger_promotions} & ${checkoutLabels.bagPage?.lbl_orderledger_coupons}`,
      price: totalPrice,
    };
  } else if (savingsTotal) {
    labelObj = { label: checkoutLabels.bagPage?.lbl_orderledger_promotions, price: savingsTotal };
  } else {
    labelObj = { label: checkoutLabels.bagPage?.lbl_orderledger_coupons, price: couponsTotal };
  }
  return savingsTotal || couponsTotal ? (
    <Row
      className="promotions-total rowMargin"
      data-locator={getLocator('order_ledger_promotion_label')}
    >
      <Col colSize={{ large: 6, medium: 4, small: 3 }}>
        <BodyCopy
          bodySize="one"
          color="primary"
          fontFamily="secondary"
          fontWeight="semibold"
          fontSize="fs15"
          className={STYLE_CHANGE_CLASS}
        >
          {`${labelObj?.label}:`}
        </BodyCopy>
      </Col>
      <Col colSize={{ large: 6, medium: 4, small: 3 }}>
        <BodyCopy
          bodySize="one"
          color="primary"
          fontFamily="secondary"
          fontWeight="semibold"
          fontSize="fs15"
          textAlign="right"
          className={STYLE_CHANGE_CLASS}
        >
          -
          <PriceCurrency
            price={currencyConversion(labelObj?.price, currencyAttributes?.[0]) || labelObj?.price}
          />
        </BodyCopy>
      </Col>
    </Row>
  ) : null;
};

const renderTotalOrder = ({
  grandTotal,
  subTotal,
  giftCardsTotal,
  orderBalanceTotal,
  spc,
  isInternationalShipping,
  calculatedEstimatedTax,
  shippingTotal,
  giftServiceTotal,
  couponsTotal,
  isEstimatedTaxFormEnabled,
  isEstimatedTaxFormEnabledSpc,
  taxesTotal,
  savingsTotal,
  isPlccShippingAddressUpdated,
  checkoutLabels,
  orderSubtotalEnhancementEnabled,
}) => {
  // Not showing gift card on cart page for SFCC-PHASE-1 as PI reconciliation does't take place on add/edit/delete item
  const giftCardTotal = spc ? giftCardsTotal : 0;
  const orderBalance = spc || isInternationalShipping ? orderBalanceTotal : grandTotal;
  const orderBalanceTax =
    ((taxesTotal || taxesTotal === 0) && spc) || isPlccShippingAddressUpdated
      ? subTotal +
        taxesTotal +
        shippingTotal +
        giftServiceTotal -
        giftCardTotal -
        couponsTotal -
        savingsTotal
      : subTotal +
        Number(calculatedEstimatedTax) +
        shippingTotal +
        giftServiceTotal -
        giftCardTotal -
        couponsTotal -
        savingsTotal;
  const priceValue =
    isEstimatedTaxFormEnabled || isEstimatedTaxFormEnabledSpc
      ? Number(orderBalanceTax)
      : Number(orderBalance);

  const formattedPriceValue = priceValue < 0 ? '0.00' : priceValue?.toFixed(2);

  return (
    <Row
      className="balance-total rowMargin"
      data-locator={getLocator('order_ledger_balance_total_label')}
    >
      <div className="balance-total-columns">
        <BodyCopy
          component="span"
          color="primary"
          fontFamily="secondary"
          fontWeight="extrabold"
          fontSize="fs18"
          className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
        >
          {giftCardTotal > 0
            ? `${checkoutLabels.bagPage?.lbl_orderledger_balance}:`
            : `${checkoutLabels.bagPage?.lbl_orderledger_total}:`}
        </BodyCopy>
        <span
          className={orderSubtotalEnhancementEnabled && 'balance-total-price text-style-change'}
        >
          <PriceCurrency price={formattedPriceValue} />
        </span>
      </div>
    </Row>
  );
};
const renderSepartor = () => {
  return (
    <div className="seperator elem-mb-XS">
      <BodyCopy
        textAlign="center"
        component="span"
        fontSize="fs14"
        className="seperator-style"
        fontFamily="secondary"
      >
        {`${getLabelFromCopyOrFromTranslation(
          `${GLOBAL_GENERIC_LABELS}.${lblOr}`,
          GlobalGenericLabels
        )}`}
      </BodyCopy>
    </div>
  );
};
const getPlccICFlag = ({
  isLoggedIn,
  isPlccCheckoutEnabled,
  isPlccCheckoutEnabledSwitch,
  rememberedUserFlag,
  plccICForRemberedUser,
}) => {
  const showLogin = plccICForRemberedUser
    ? rememberedUserFlag || isLoggedIn
    : !rememberedUserFlag && isLoggedIn;
  return !isCanada() && isPlccCheckoutEnabledSwitch && showLogin && isPlccCheckoutEnabled;
};

// eslint-disable-next-line sonarjs/cognitive-complexity, complexity
const getBody = (props) => {
  const {
    className,
    summaryData,
    pageCategory,
    orderLedgerAfterView,
    bagLoading,
    isConfirmationPage,
    isVenmoPaymentInProgress,
    venmoPayment,
    isShowLoyaltyBanner,
    // prop which shows optimistic UI update process is going on
    spc,
    isCartLoading, // prop which shows optimistic UI update process is going on
    getEstimatedTaxAction,
    getIsFromEstimatedTaxForm,
    taxFromDefaultShippingAddress,
    isEstimatedTaxFormEnabled,
    isEstimatedTaxFormEnabledSpc,
    zipCode,
    zipCodeTaxError,
    isTaxCalculated,
    isInternationalShipping,
    currencyAttributes,
    isLoggedIn,
    isPlccCheckoutEnabled,
    isPlccCheckoutEnabledSwitch,
    rememberedUserFlag,
    orderType,
    isNonCacheDataLoaded,
    plccShippingAddressUpdateActn,
    containsExtendedOrder,
    isPlccShippingAddressUpdated,
    isAddToBagInProgress,
    userContactInfo,
    userName,
    isPlccIsShippingAddressModalOpenAtn,
    IsPlccICAddressModalOpen,
    handlePlccCheckout,
    userShippingAddress,
    verifyAllExpiredCoupons,
    userDefaultStore,
    updateStoreItem,
    productItems,
    bossAndPreOrder,
    bossAndGC,
    resetEDDCall,
    trackAnalyticClick,
    isPlccICPickupModalOpenAtn,
    isPlccICPickupModalOpen,
    orderDetails,
    isLoginV2FlowEnabled,
    isHasPickUpAlternatePerson,
    bossGCAndPreOrderCase,
    nonCacheBagLoading,
    isStickyCheckoutButtonEnabled,
    renderCondForPLCCTopBanner,
    checkoutLabels,
    freeShippingMessagingEnabled,
    defaultAddressForRemUser,
    plccICForRemberedUser,
    plccLoginModalState,
    togglePlccModalStateAction,
    freeShippingThreshold,
    isFreeShippingLedgerMessageEnabled,
    orderSubtotalEnhancementEnabled,
    productTotal,
    productTotalConfirmation,
    bossInEligible,
    isFreeShippingCouponApplied,
    updateSectionStateAtn,
    shipments,
    orderTrackingEnhancementEnabled,
    // eslint-disable-next-line max-params
  } = props;
  const {
    itemsCount,
    subTotal,
    couponsTotal,
    savingsTotal,
    giftServiceTotal,
    shippingTotal,
    taxesTotal,
    grandTotal,
    giftCardsTotal,
    orderBalanceTotal,
    totalOrderSavings,
    isOrderHasShipping,
    calculatedEstimatedTax,
    shippingValues,
  } = summaryData;
  const shippingDetails = shipments?.filter((shipment) => shipment?.c_fromStoreId === null)[0];
  const shipmentValue = shippingDetails?.productTotal;

  const toolTipMinWidth = '205px';
  const textSize = getAfterPaySize();
  const shipmentsObject = shippingValues && JSON.parse(JSON.stringify(shippingValues));

  const shippingMethodCodeSelected =
    orderDetails?.shipments?.[0]?.shippingMethod?.c_code || shipmentsObject?.method?.code;

  const isShippingMethodApplicableForFreeShipping = BAGPAGE_CONSTANTS.FREE_SHIPMENT_CODES?.includes(
    shippingMethodCodeSelected
  );
  const isSTHBasket = orderType === 'PURE_ECOM' || orderType === 'ECOM' || orderType === 'ECOM_MIX';
  const cartValueGreaterThanThreshold = shipmentValue >= freeShippingThreshold;
  const hideFreeShippingMessage = isFreeShippingCouponApplied || cartValueGreaterThanThreshold;
  const showFreeShippingMsg =
    !isConfirmationPage &&
    isSTHBasket &&
    isShippingMethodApplicableForFreeShipping &&
    isFreeShippingLedgerMessageEnabled &&
    !hideFreeShippingMessage;
  const showSubTotalWithDiscounts = savingsTotal || giftServiceTotal || couponsTotal;
  const totalProductPrice = isConfirmationPage ? productTotalConfirmation : productTotal;
  const subtotalLabel = orderSubtotalEnhancementEnabled
    ? `${getLabelFromCopyOrFromTranslation(
        `${GLOBAL_GENERIC_LABELS}.${lblItemSubtotal}`,
        GlobalGenericLabels
      )} (${itemsCount}):`
    : `${getLabelFromCopyOrFromTranslation(
        `${GLOBAL_GENERIC_LABELS}.${lblItems}`,
        GlobalGenericLabels
      )} (${itemsCount}):`;
  return (
    <React.Fragment>
      <Grid className={`${''} elem-mb-MED`} data-locator={getLocator('order_ledger_section_label')}>
        {conditionForSkeleton(isConfirmationPage, summaryData, bagLoading) || isCartLoading ? (
          <>
            <Row
              className="items-total rowMargin"
              data-locator={getLocator('order_ledger_item_label')}
            >
              <Col colSize={{ large: 6, medium: 4, small: 3 }}>
                <BodyCopy
                  bodySize="one"
                  color="primary"
                  fontFamily="secondary"
                  textAlign="left"
                  fontWeight="semibold"
                  fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
                  dataLocator="orderLedgerCount"
                  className={orderSubtotalEnhancementEnabled && STYLE_CHANGE_CLASS}
                >
                  {subtotalLabel}
                </BodyCopy>
              </Col>
              <Col colSize={{ large: 6, medium: 4, small: 3 }}>
                <BodyCopy
                  bodySize="one"
                  color="primary"
                  fontFamily="secondary"
                  fontWeight="semibold"
                  fontSize={orderSubtotalEnhancementEnabled ? ['fs14', 'fs15'] : 'fs16'}
                  textAlign="right"
                  className={
                    (savingsTotal || couponsTotal) &&
                    orderSubtotalEnhancementEnabled &&
                    `strike-through-line ${STYLE_CHANGE_CLASS}`
                  }
                >
                  <PriceCurrency price={subTotal} />
                </BodyCopy>
              </Col>
            </Row>
            {!orderSubtotalEnhancementEnabled &&
              renderSavingsTotal(savingsTotal, className, currencyAttributes, checkoutLabels)}
            {!orderSubtotalEnhancementEnabled &&
              renderCouponTotal(couponsTotal, currencyAttributes, checkoutLabels)}
            {orderSubtotalEnhancementEnabled &&
              renderCouponsAndPromoTotal(
                savingsTotal,
                className,
                currencyAttributes,
                checkoutLabels,
                couponsTotal
              )}
            {createRowForGiftServiceTotal(
              className,
              giftServiceTotal,
              checkoutLabels,
              orderSubtotalEnhancementEnabled
            )}
            {orderSubtotalEnhancementEnabled && showSubTotalWithDiscounts
              ? renderProductTotalWithDiscounts(totalProductPrice, className, currencyAttributes)
              : null}
            {orderSubtotalEnhancementEnabled && <div className="horizontal-line" />}
            {orderHasShipping(
              isOrderHasShipping,
              shippingTotal,
              checkoutLabels,
              showFreeShippingMsg,
              orderSubtotalEnhancementEnabled
            )}
            {showFreeShippingMsg &&
              freeShippingMessage(freeShippingThreshold, orderSubtotalEnhancementEnabled)}
            {renderEstimatedTax({
              taxesTotal,
              isEstimatedTaxFormEnabled,
              zipCode,
              getEstimatedTaxAction,
              getIsFromEstimatedTaxForm,
              taxFromDefaultShippingAddress,
              zipCodeTaxError,
              isTaxCalculated,
              spc,
              isNonCacheDataLoaded,
              plccShippingAddressUpdateActn,
              orderType,
              isAddToBagInProgress,
              checkoutLabels,
              orderSubtotalEnhancementEnabled,
            })}
            {isConfirmationPage && (
              <Row
                fullBleed={spc}
                className={`balance-total rowMargin ${isConfirmationPage && 'confirm-block'}`}
                data-locator={getLocator('order_ledger_balance_total_label')}
              >
                <div className="balance-total-columns">
                  <span>{checkoutLabels.bagPage?.lbl_orderledger_totalConfirmation}</span>
                  {isCartLoading ? (
                    <LoaderSkelton />
                  ) : (
                    <span className={orderSubtotalEnhancementEnabled && 'balance-total-price'}>
                      <PriceCurrency price={grandTotal} />
                    </span>
                  )}
                </div>
              </Row>
            )}
            {/* {Hiding gift card on cart page for SFCC-PHASE-1 as PI reconciliation does't take place on add/edit/delete item} */}
            {(spc || isConfirmationPage) &&
              renderGiftsCardTotal(
                giftCardsTotal,
                checkoutLabels,
                grandTotal,
                spc,
                undefined,
                orderSubtotalEnhancementEnabled
              )}
            {!isConfirmationPage &&
              renderTotalOrder({
                grandTotal,
                subTotal,
                giftCardsTotal,
                orderBalanceTotal,
                spc,
                isInternationalShipping,
                calculatedEstimatedTax,
                shippingTotal,
                giftServiceTotal,
                couponsTotal,
                isEstimatedTaxFormEnabled,
                isEstimatedTaxFormEnabledSpc,
                taxesTotal,
                savingsTotal,
                isPlccShippingAddressUpdated,
                checkoutLabels,
                orderSubtotalEnhancementEnabled,
              })}
            {renderTotalOrderSavings(
              totalOrderSavings,
              grandTotal,
              toolTipMinWidth,
              currencyAttributes,
              checkoutLabels,
              orderSubtotalEnhancementEnabled
            )}
          </>
        ) : (
          <OrderSummarySkeleton />
        )}

        {pageCategory === 'bagPage' && !containsExtendedOrder && (
          <Row className="after-pay-msg">
            <Col colSize={{ large: 12, medium: 10, small: 6 }}>
              <AfterPayMessaging
                offerPrice={orderBalanceTotal}
                dataSize={textSize}
                isOrderThresholdEnabled
                isPriceBold
                disableForGC
                centered
              />
            </Col>
          </Row>
        )}

        {pageCategory === 'bagPage' &&
          getPlccICFlag({
            isLoggedIn,
            isPlccCheckoutEnabled,
            isPlccCheckoutEnabledSwitch,
            rememberedUserFlag,
            plccICForRemberedUser,
          }) &&
          !isInternationalShipping && (
            <div className="elem-mr-XS elem-ml-XS">
              <PlccCheckout
                className={className}
                orderType={orderType}
                userContactInfo={userContactInfo}
                userName={userName}
                isPlccIsShippingAddressModalOpenAtn={isPlccIsShippingAddressModalOpenAtn}
                IsPlccICAddressModalOpen={IsPlccICAddressModalOpen}
                handlePlccCheckout={handlePlccCheckout}
                userShippingAddress={userShippingAddress}
                verifyAllExpiredCoupons={verifyAllExpiredCoupons}
                userDefaultStore={userDefaultStore}
                updateStoreItem={updateStoreItem}
                productItems={productItems}
                bossAndPreOrder={bossAndPreOrder}
                bossAndGC={bossAndGC}
                resetEDDCall={resetEDDCall}
                trackAnalyticClick={trackAnalyticClick}
                isPlccICPickupModalOpenAtn={isPlccICPickupModalOpenAtn}
                isPlccICPickupModalOpen={isPlccICPickupModalOpen}
                orderDetails={orderDetails}
                isLoginV2FlowEnabled={isLoginV2FlowEnabled}
                isHasPickUpAlternatePerson={isHasPickUpAlternatePerson}
                pageCategory={pageCategory}
                bossGCAndPreOrderCase={bossGCAndPreOrderCase}
                nonCacheBagLoading={nonCacheBagLoading}
                defaultAddressForRemUser={defaultAddressForRemUser}
                rememberedUserFlag={rememberedUserFlag}
                plccICForRemberedUser={plccICForRemberedUser}
                plccLoginModalState={plccLoginModalState}
                togglePlccModalStateAction={togglePlccModalStateAction}
                bossInEligible={bossInEligible}
                updateSectionStateAtn={updateSectionStateAtn}
                orderTrackingEnhancementEnabled={orderTrackingEnhancementEnabled}
              />
              {renderSepartor()}
            </div>
          )}
        {orderLedgerAfterView}

        {!freeShippingMessagingEnabled &&
          pageCategory === 'bagPage' &&
          !isShowLoyaltyBanner &&
          !isInternationalShipping && (
            <div className="hideLoyaltyBanner">
              <FreeShippingBanner />
            </div>
          )}
        {isVenmoPaymentInProgress && venmoPayment && containsExtendedOrder && (
          <section className="venmo-payment-method-wrapper">
            <BodyCopy
              color="gray.900"
              fontFamily="secondary"
              fontSize="fs14"
              textAlign="left"
              className="venmo-paid-text"
            >
              {checkoutLabels.bagPage?.lbl_confirmation_paid_with_venmo}
            </BodyCopy>
            <CardImage card={venmoPayment} cardNumber={venmoPayment.userName} />
          </section>
        )}
        {(!isShowLoyaltyBanner ||
          (isMobileWeb() && isPlccCheckoutEnabled) ||
          (isStickyCheckoutButtonEnabled && isMobileWeb())) &&
          typeof renderCondForPLCCTopBanner === 'function' &&
          !renderCondForPLCCTopBanner() && (
            <div className="hideLoyaltyBanner">{renderLoyaltyBanner(pageCategory)}</div>
          )}
      </Grid>
      <RenderPerf.Measure name={PRICING_VISIBLE} />
    </React.Fragment>
  );
};

export default { getBody, createRowForGiftServiceTotal };
